require("./dataset/DatasetModel");

var echarts = require("../echarts");

echarts.extendComponentView({
  type: 'dataset'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/dataset.js
// module id = +Dgo
// module chunks = 0 1